module.exports = {"title":"POS Settings","datatable":{"code":"Site ID","name":"Station Name"}};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en_sentinel/central_settings.php
// module id = nwaF
// module chunks = 99